import React from "react";
import { useSettingsPrefetch } from "@/dashboard/features/settings/shared/hooks/useSettingsPrefetch";
import { useTalentPrefetch } from "@/dashboard/shared/hooks/useTalentPrefetch";
import { usePagesPrefetch } from "@/dashboard/shared/hooks/usePagesPrefetch";
import { useSelector } from "react-redux";

/**
 * Global prefetcher component that handles prefetching for different sections
 * Should be placed high in the component tree (e.g., in App.jsx or main layout)
 */
const GlobalPrefetcher = () => {
  const user = useSelector((state) => state.auth.user);

  // Prefetch settings data when user enters settings
  useSettingsPrefetch(user);

  // Prefetch talent data when user enters talent sections
  useTalentPrefetch(user);

  // Prefetch pages data when user enters pages sections
  usePagesPrefetch(user);

  // This component doesn't render anything - it just handles prefetching
  return null;
};

export default GlobalPrefetcher;
